// A19.05 emergency (life-at-risk) disclosure requests — module-local data layer.
// REAL backend (/admin/emergency-requests). Tracking only.
import { api } from '@/lib/api'

export interface EmergencyRequest {
  id: number
  agency: string
  officer: string
  urgency: string
  legal_basis: string
  subject: string
  description: string
  disclosed: string
  status: string
  response_note: string
  responded_at: string | null
  created_at: string
}

export const fetchEmergency = (status = '', s?: AbortSignal) =>
  api.get<{ requests: EmergencyRequest[] }>('/admin/emergency-requests', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.requests ?? [])
export const createEmergency = (body: {
  agency: string
  officer: string
  contact: string
  legal_basis: string
  urgency: string
  subject_user_id?: number
  subject_ref: string
  description: string
}) => api.post<{ id: number }>('/admin/emergency-requests', body)
export const updateStatus = (id: number, status: string, response_note: string, disclosed: string) =>
  api.post(`/admin/emergency-requests/${id}/status`, { status, response_note, disclosed })
export const deleteEmergency = (id: number) => api.del(`/admin/emergency-requests/${id}`)

export const URGENCIES = [
  { key: 'critical', label: 'Критично', pill: 'bg-danger/10 text-danger' },
  { key: 'high', label: 'Высокая', pill: 'bg-warning/10 text-warning' },
  { key: 'medium', label: 'Средняя', pill: 'bg-accent/10 text-accent' },
] as const
export const STATUSES = [
  { key: 'received', label: 'Получен', pill: 'bg-warning/10 text-warning' },
  { key: 'reviewing', label: 'Рассмотрение', pill: 'bg-accent/10 text-accent' },
  { key: 'disclosed', label: 'Раскрыто', pill: 'bg-success/10 text-success' },
  { key: 'denied', label: 'Отказано', pill: 'bg-surface-3 text-tertiary' },
] as const

export function urgencyMeta(u: string) {
  return URGENCIES.find((x) => x.key === u) ?? URGENCIES[1]
}
export function statusMeta(s: string) {
  return STATUSES.find((x) => x.key === s) ?? STATUSES[0]
}

export const EM_STR = {
  title: 'Экстренные запросы (угроза жизни)',
  desc: 'Ускоренные запросы правоохранителей — учёт органа/основания/раскрытия. Только отслеживание',
  create: 'Новый запрос',
  agency: 'Орган',
  officer: 'Сотрудник',
  contact: 'Контакт',
  legalBasis: 'Основание',
  urgency: 'Срочность',
  subjectRef: 'Субъект (ID/контакт)',
  description: 'Описание',
  add: 'Создать',
  reviewing: 'В рассмотрение',
  disclose: 'Раскрыть',
  deny: 'Отказать',
  delete: 'Удалить',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет запросов',
  all: 'Все',
  subject: 'Субъект',
  disclosed: 'Раскрыто',
} as const
